<a [href]="link" class="global-search-overlay-result" [ngClass]="['global-search-overlay-result--type-' + resultData.type]" *ngIf="resultData">
  <div class="global-search-overlay-result__image">
    <brt-image [image]="resultData.image"></brt-image>
  </div>

  <div class="global-search-overlay-result__content" #contentEl>
    <div class="global-search-overlay-result__type">
      <brt-item-tag [title]="stringType" [clickable]="false"></brt-item-tag>
      <brt-item-tag [title]="'Grüner Beruf'" *ngIf="resultData.isGreen" [clickable]="false" [before-icon]="'green-jobs'" [color]="'green-light'"></brt-item-tag>
    </div>
    <div class="global-search-overlay-result__title" [innerHTML]="resultData.title"></div>
    <div class="global-search-overlay-result__quote" [innerHTML]="resultData.quote"></div>
  </div>
</a>
